module.exports = __webpack_public_path__ + "img/authenticated.97813400.png";